import {Link} from "react-router-dom";
import React, {useState} from "react";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import '../style/navMenu/navMenu.css';
import Logout from "./Logout";

//Drop down component for your account
function Dropdown() {
    return (
        <NavItem icon={<AccountCircleOutlinedIcon fontSize={"large"}/>}>
            <div className={"caret"}/>
            <DropDownBox/>
        </NavItem>
    )
}

function DropDownBox() {
    function DropDownItem(props) {
        return (
            <a className={"menu-item"}>
                {props.children}
            </a>
        );
    }

    return (
        <div className={"drop-down"}>
            <DropDownItem>
                <Link to={'myprofile'} className={"link"}>
                    My Profile
                </Link>
            </DropDownItem>
            <DropDownItem>
                <Link to={'/settings'} className={"link"}>
                    Settings
                </Link>
            </DropDownItem>
            {/* <DropDownItem>
                <Link to={'/suspension'} className={"link"}>
                    Suspension
                </Link>
            </DropDownItem> */}
            <DropDownItem>
                <Link to={'/users'} className={"link"}>
                    Users
                </Link>
            </DropDownItem>
            <DropDownItem>
                <Logout className={"link"} />
            </DropDownItem>
        </div>

    );
}

//Navigation with Items including the icon button
function NavItem(props) {
    const [open, setOpen] = useState(false);
    const timeoutRef = React.useRef(null);

    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setOpen(true);
    };

    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setOpen(false);
        }, 150);
    };

    return (
        <li
            className={"nav-item"}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <a className={"icon-button"} onClick={() => setOpen(!open)}>
                {props.icon}
            </a>
            {open && props.children}
        </li>
    );
}

export default Dropdown;
